import { parseResourceFileToObj } from '&/utils/common';

const modulesFiles = require.context('@/locales/zh-CN', true, /\.js$/);

let lang = parseResourceFileToObj(modulesFiles);

export default lang;
